import { ArrowRight, HandHeart } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function Partnership() {
  return (
    <section id="partnership" data-testid="partnership-section" className="grain bg-atlantic py-24 lg:py-32">
      <span id="support" className="block" aria-hidden="true" />
      <Reveal className="relative mx-auto max-w-5xl px-5 text-center lg:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold">Partnerships</p>
        <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-white sm:text-4xl lg:text-[2.75rem]">
          Build the Bridge With Us
        </h2>
        <p className="mx-auto mt-7 max-w-3xl text-base leading-relaxed text-white/70 sm:text-lg">
          Atlantic Bridge works with universities, newsrooms, foundations, cultural institutions, governments,
          civil-society organizations and responsible private-sector partners while preserving editorial independence
          and transparency.
        </p>
        <a
          data-testid="partnership-explore-button"
          href="#contact"
          className="group mt-10 inline-flex items-center gap-2 bg-gold px-8 py-4 text-sm font-semibold tracking-wide text-atlantic transition-colors hover:bg-gold-light"
        >
          Explore Partnerships
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </a>
        <div className="mx-auto mt-14 flex max-w-xl items-center justify-center gap-3 border-t border-white/10 pt-8 text-sm text-white/55">
          <HandHeart size={16} className="shrink-0 text-gold" />
          <p>
            Independent journalism depends on reader support. To support our work,{" "}
            <a data-testid="support-contact-link" href="#contact" className="font-semibold text-gold underline-offset-4 hover:underline">
              contact us
            </a>
            .
          </p>
        </div>
      </Reveal>
    </section>
  );
}
